module.exports = __webpack_public_path__ + "assets/12169334420bfbd0e180a8ca7527de4b.jpg";